import * as Sentry from '@sentry/react';

function ErrorFallback() {
  return (
    <div className="flex flex-col items-center justify-center p-6">
      <div className="text-lg font-semibold text-destructive mb-4">Something went wrong.</div>
      <div className="text-sm text-foreground/50">Please refresh the page or try again later.</div>
    </div>
  );
}

export default function ErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
